import _objectDestructuringEmpty from "@babel/runtime/helpers/esm/objectDestructuringEmpty";
import I18n from 'I18n';
import UISelect from 'UIComponents/input/UISelect';
import { getProxyUrl, getPublicLang } from 'academy-common-lib/utils/url';
import { usePublicSearch } from '../publicSearchQueries';
import { useEffect, useMemo, useState } from 'react';
import useDebouncedValue from 'academy-common-lib/hooks/useDebouncedValue';
import styled, { theme } from 'academy-common-lib/utils/Styling';
import UILink from 'UIComponents/link/UILink';
import FloatingAlertStore from 'UIComponents/alert/FloatingAlertStore';
import usageTracker from '../../../utils/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledLink = styled(UILink).attrs({
  use: 'unstyled'
}).withConfig({
  displayName: "PublicSearch__StyledLink",
  componentId: "sc-1dpm2kd-0"
})(["display:block;min-height:40px;padding:8px 20px;color:", " !important;", ""], theme.colors.OBSIDIAN, props => props.allResults && `
  color: ${theme.colors.EERIE} !important;
  text-decoration: underline !important;
  `);
const SearchResultItem = ({
  children,
  option
}) => {
  if (option.isLink) {
    return /*#__PURE__*/_jsx(StyledLink, {
      allResults: option.isAllResultsLink ? 1 : 0,
      href: option.value,
      children: option.text
    });
  }
  return children;
};
const PublicSearch = _ref => {
  let props = Object.assign({}, (_objectDestructuringEmpty(_ref), _ref));
  const [value, setValue] = useState('');
  const debouncedValue = useDebouncedValue(value, 200);
  const {
    publicSearchData,
    publicSearchLoading,
    publicSearchError
  } = usePublicSearch(debouncedValue, getPublicLang());
  useEffect(() => {
    if (!publicSearchLoading && publicSearchError) {
      FloatingAlertStore.addAlert({
        type: 'danger',
        message: I18n.text('academyPublic.publicNavSearch.errorMessage'),
        titleText: I18n.text('academyPublic.publicNavSearch.errorTitle')
      });
    }
  }, [publicSearchError, publicSearchLoading]);
  const selectOptions = useMemo(() => {
    if (!publicSearchData) return [];
    const options = publicSearchData.slice(0, 3).map(({
      metadata,
      pagePath,
      type
    }) => {
      return {
        text: metadata[0].name,
        value: getProxyUrl(['cert', 'course'].includes(type) ? `courses/${pagePath}` : `lessons/${pagePath}`, getPublicLang()),
        isLink: true
      };
    });
    return publicSearchData.length <= 3 ? options : [...options, {
      text: I18n.text('academyPublic.publicNavSearch.seeAll', {
        number: publicSearchData.length
      }),
      value: getProxyUrl(`results?q=${debouncedValue}`, getPublicLang()),
      isLink: true,
      isAllResultsLink: true
    }];
  }, [debouncedValue, publicSearchData]);
  return /*#__PURE__*/_jsx(UISelect, Object.assign({
    anchorType: "input",
    filterOptions: false,
    isLoading: publicSearchLoading,
    itemComponent: SearchResultItem,
    onChange: e => {
      window.location.href = e.target.value;
      usageTracker.track('navInteraction', {
        action: 'search-item-clicked',
        searchQuery: debouncedValue,
        href: e.target.value
      });
    },
    onInputValueChange: e => {
      setValue(e.target.value);
    },
    options: selectOptions,
    placeholder: I18n.text('academyPublic.publicNavSearch.placeholder'),
    value: value
  }, props));
};
export default PublicSearch;